import styled from 'styled-components';

const Style = styled.div`
  margin-top: var(--size-lg);
  
  .react-flow__node-default {
    transition: .4s box-shadow, .4s border;
    &.selected {
      border: 1px solid black;
    }
  }

  .project-frame .body {
    margin-left: var(--size-lg);
    margin-right: var(--size-lg);
    margin-bottom: var(--size-lg);
    width: calc(100% - 48px);
  }
  
  .node {
    cursor: pointer;

    * {
      cursor: pointer;
    }
    
    .link {
      color: #001529;
      font-weight: 300;
    }

    &:hover {
      .link {
        color: var(--mmt-primary-70);
        text-decoration: underline;
      }
    }
  }

  .react-flow__handle {
    background: white;
    border: 1px solid var(--mmt-primary-60);
  }

  .react-flow__controls {
    bottom: var(--size-lg);
    left: var(--size-lg);
  }

  .react-flow__node-default.selected, .react-flow__node-default.selected:hover {
    box-shadow: 0px 12px 16px -4px rgba(16, 24, 40, 0.08), 0px 4px 6px -2px rgba(16, 24, 40, 0.03);
  }

  .react-flow__node-default {
    border-color: transparent;
    box-shadow: 0px 12px 16px -4px rgba(16, 24, 40, 0.08), 0px 4px 6px -2px rgba(16, 24, 40, 0.03);
  }

`;

export default Style;
